import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import Select from "react-select";

interface OptionType {
  label: string;
  value: string | number;
}

interface Props {
  name: string;
  label: string;
  options: OptionType[];
  value: string;
  placeholder: string;
  errors: any;
  touched: any;
  inputValue: any;
  queryName: string;
  onChange: (e: any) => void;
  handleCustomerValues: (value: any) => void;
  disabled?: boolean;
  optional?: boolean;
}

const LabelInsideSelectController = (props: Props) => {
  const { setFieldValue, setFieldTouched } = useFormikContext<any>();
  const selectedOption =
    props.value === ""
      ? null
      : props.options.find((option) => option.value === props.value);

  const showError =
    !props.optional &&
    props.errors?.[props.name] &&
    props.touched?.[props.name];

  const handleChangeInputValuesDropdown = (selected: OptionType | null) => {
    setFieldValue(props.name, selected?.value || "");
    props.handleCustomerValues(selected);
  };

  return (
    <div className="text-field-section">
      {props.label && (
        <label htmlFor={props.name}>
          {props.label} {!props.optional && <span className="required">*</span>}
        </label>
      )}

      <div className={`input-container-wrapper ${showError ? "error" : ""}`}>
        <Select
          name={props.name}
          id={props.name}
          options={props.options}
          value={selectedOption}
          onChange={handleChangeInputValuesDropdown}
          onBlur={() => setFieldTouched(props.name, true)}
          placeholder={props.placeholder}
          isDisabled={props.disabled}
          className="input-control select-control"
        />

        <div className="error-line">
          {showError && <span>{props.errors[props.name]}</span>}
        </div>
      </div>
    </div>
  );
};

export default LabelInsideSelectController;
